import { useLocalization } from "@fluent/react";
import { Button , ContentCard } from "@narmi/design_system";
import { catcat as cc } from "cerulean";
import { useMarketingTarget } from "byzantine/src/dbbl/businessLogic/modules/marketing/marketing.container";
import { translateMarketingCampaign } from "byzantine";
import utils from "byzantine/src/utils";
import type { MarketingCardProps, MarketingTarget } from "./types";

const MarketingCard = ({ address }: MarketingCardProps) => {
  const { l10n } = useLocalization();
  const { loading, config, linkUrl, opensInNewTab } =
    useMarketingTarget<MarketingTarget>(address);

  if (loading || !config || !linkUrl) {
    return null;
  }

  const translatedCampaign = translateMarketingCampaign(
    {
      uuid: address,
      asset_config: {
        title: config.title,
        body: config.body,
        icon: config.icon,
        linkText: config.linkText
      }
    },
    l10n
  );

  const {
    title,
    body,
    icon,
    linkText: actionText
  } = translatedCampaign.asset_config || {};

  return (
    <ContentCard kind="elevated">
      <div className="fontColor--theme--primary fontSize--l  margin--bottom--s fontWeight--bold alignChild--left-center">
        <span
          className={cc([
            utils.ndsIconPrepend(icon),
            "margin--right--xs",
            "fontSize--heading2"
          ])}
        />
        <div>{title}</div>
      </div>
      <p className="margin--bottom--s">{body}</p>
      <Button
        as="a"
        href={linkUrl}
        kind="plain"
        ariaLabel={`${title} - ${actionText}`}
        label={actionText || "Learn more"}
        testId="marketing-card-learn-more"
        rel="noreferrer"
        target={opensInNewTab ? "_blank" : "_self"}
      />
    </ContentCard>
  );
};

export default MarketingCard;
